import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { cx } from '../../utils/cx';
import s from './Container.module.css';

export type ContainerProps = ComponentPropsWithoutRef<'div'> & {
  as?: ElementType;
  /** `content` = 1120px app width; `readable` = 640px for forms and prose. */
  width?: 'content' | 'readable';
};

/** Centered page column with the responsive page gutter. */
export function Container({
  as: Tag = 'div',
  width = 'content',
  className,
  ...rest
}: ContainerProps) {
  return <Tag className={cx(s.container, className)} data-width={width} {...rest} />;
}
